import { useAccountContext } from 'src/components/account/context'
import { maskCurrency } from 'src/utils/convertCurrency'
import DoubtsIcon from 'src/components/Icons/DoubtsIcon'
import SmallArrowRight from 'src/components/Icons/SmallArrowRight'
import IconCurrencyBlue from 'src/components/Icons/IconCurrencyBlue'
import CloseModalIcon from 'src/components/Icons/CloseModalIcon'
import BlockIconCashback from 'src/components/Icons/BlockIconCashback'
import StarIcon from 'src/components/Icons/StarIcon'
import { useEffect, useState } from 'react'

type QtsInfoProps = {
  title: string
  url: string
}

interface BenefitModalProps {
  modalContent: {
    modalBanner?: string
    modalTitle?: string
    modalSubtitle?: string
    modalText: string
    howToUse: string
    modalButton: string
    modalButtonLink?: string
    modalButtonMode: string
    modalTiersImg?: string
    questions?: QtsInfoProps[]
  }
  onClose: () => void
}

export default function BenefitModal({
  modalContent,
  onClose,
}: BenefitModalProps) {
  const { cashBackBalance, isLoggedIn } = useAccountContext()

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(true)
  }, [onClose])

  const qts = modalContent.questions

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleEsc)

    return () => window.removeEventListener('keydown', handleEsc)
  }, [onClose])

  return (
    <>
      <button
        className="fixed inset-0 bg-black/40 z-[9998]"
        onClick={onClose}
      />

      <div
        className={`fixed right-0 top-0 bottom-0 z-[9999] w-full md:w-[375px] bg-white shadow-xl overflow-y-auto font-inter transform transition-all duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex justify-between items-start w-full p-5 header-modal">
          <button onClick={onClose} className="block ml-auto">
            <CloseModalIcon />
          </button>
        </div>

        <div
          className="flex items-center gap-2 banner-modal w-full h-[214px] mb-[38px] bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${
              modalContent.modalBanner
                ? modalContent.modalBanner
                : 'https://decathlonstoreapp.vteximg.com.br/arquivos/bgCashbackPeopleMob.png'
            })`,
          }}
        >
          <h3 className="block mt-auto mb-[16px] px-[16px] text-xl font-medium text-white leading-[140%]">
            {modalContent.modalTitle}
          </h3>
          <div className="overlay-bg" />
        </div>

        {modalContent.modalSubtitle === 'Cashback' ? (
          <div className="px-6 py-4 w-full left-0 right-0 top-[24.7%] items-center mx-auto font-inter text-white absolute border border-[#D9DDE1] max-w-[343px] bg-white">
            <span className="text-xs text-[#616161]">Cashback disponível</span>
            <div className="flex justify-between text-xl pb-[20px]">
              <span className="font-inter">
                {isLoggedIn ? (
                  maskCurrency(cashBackBalance ?? 0)
                ) : (
                  <div className="flex gap-2 items-center">
                    <span className="font-inter text-[#101010] font-medium text-[24px]">
                      R$
                    </span>
                    <BlockIconCashback />
                  </div>
                )}
              </span>
              <IconCurrencyBlue />
            </div>
            {isLoggedIn ? (
              <></>
            ) : (
              <div className="pt-[20px] border-t border-t-[#D9DDE1]">
                <p className="text-[#616161] text-sm text-center">
                  Se torne membro para ver seu
                  <br /> Cashback e outros benefícios :)
                </p>
              </div>
            )}
          </div>
        ) : (
          <></>
        )}

        <div
          className={`main-text-modal block border-b mx-[24px] border-b-[#D9DDE1] pb-[24px] mb-[24px] ${
            modalContent.modalSubtitle === 'Cashback' ? 'mt-[147px]' : ''
          }`}
        >
          <StarIcon />
          <p className="text-lg font-bold mt-[12px] leading-[28px] text-[#101010]">
            {modalContent.modalSubtitle}
          </p>
          <p className="text-sm leading-[150%] text-[#687787]">
            {modalContent.modalText}
          </p>
        </div>

        <div className="how-to-use-modal px-[24px]">
          <p className="text-lg font-bold mt-[12px] leading-[28px] text-[#101010]">
            Como Usar
          </p>
          <p className="text-sm leading-[150%] text-[#687787]">
            {modalContent.howToUse}
          </p>
        </div>

        {modalContent.modalTiersImg ? (
          <div className="my-[24px] block px-[24px]">
            <img
              className="w-full h-auto"
              src={modalContent.modalTiersImg}
              alt="tiers-info-img"
            />
          </div>
        ) : (
          <></>
        )}

        {qts && qts.length > 0 ? (
          <div className="block mt-[24px] mb-[20px] px-[24px]">
            <p className="text-lg text-black leading-[28px] mb-[4px]">
              Dúvidas
            </p>
            {qts.map((qtn: { title: string; url: string }, _idx) => (
              <a
                className="flex gap-[16px] text-left mb-[4px] p-[16px] text-base leading-[24px] font-semibold border border-[#D9DDE1]"
                key={qtn.title}
                href={qtn.url}
              >
                <DoubtsIcon />
                {qtn.title}
                <SmallArrowRight className="flex ml-auto mt-[5px]" />
              </a>
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  )
}
